import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Formik, ErrorMessage } from "formik";
import { createAccountSchema } from "../../utils/yup";
import { fetchEmailData, createUser } from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../icons/CloseIcon";
import { toast } from "react-toastify";

const SignUpPage = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [email_exits, setemail_exits] = useState(false);
  const [countries, setCountries] = useState("AED");
  const navigate = useNavigate();

  const loadEmailDetails = async (email_id) => {
    try {
      const result = await fetchEmailData(email_id);
      const message = result?.message ?? "";
      const currency_values = result?.currency_value ?? "";

      if (result && message === "exist") {
        setemail_exits(true);
        setCountries(currency_values);
      } else {
        setemail_exits(false);
        setCountries("AED");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading(true);
      values.user_source = "Webshop";

      if (values.register_type === "individual") {
        values.country = values.country_individual;
      }

      const result = await createUser(values);

      setLoading(false);

      if (result?.message) {
        toast.error(result?.message);
      } else {
        navigate("/account-created?email=" + values.email);
        toast.success(result);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }

    setSubmitting(false);
  };

  return (
    <section className="account py-40">
      <Formik
        initialValues={{
          register_type: "company",
          email: "",
          password: "",
          password_confirmation: "",
          first_name: "",
          last_name: "",
          country: "AED",
          company_name: "",
          phone_nr: "",
          phone_area_code: "+971",
          country_individual: "AED",
        }}
        onSubmit={onSubmit}
        validationSchema={createAccountSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => (
          <Form>
            <div className="container container-lg">
              <div className="row gy-4">
                {/* Register Card Start */}
                <div className="col-xl-3"></div>
                <div className="col-xl-6">
                  <div className="row gy-4">
                    <div className="col-xl-6">
                      <div className="logo px-16 d-block">
                        <Link to="/" className="mobile-menu__logo">
                          <img
                            src="../../assets/images/logo/dhofar-logo.svg"
                            alt="Logo"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="col-xl-6 d-flex justify-content-end align-items-center">
                      <Link to="/">
                        <CloseIcon size={14} className="text-neutral-900" />
                      </Link>
                    </div>
                  </div>
                  <h4 className="text-center">
                    <b>Register</b>
                  </h4>
                  <div className="product-dContent border rounded-24">
                    <div className="product-dContent__header flex-between flex-wrap">
                      <ul
                        className="nav common-tab nav-pills mb-3"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              values.register_type === "company" ? "active" : ""
                            }`}
                            id="company-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#company"
                            type="button"
                            role="tab"
                            aria-controls="company"
                            aria-selected="true"
                            onClick={() =>
                              setFieldValue("register_type", "company")
                            }
                          >
                            Company
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              values.register_type === "individual"
                                ? "active"
                                : ""
                            }`}
                            id="individual-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#individual"
                            type="button"
                            role="tab"
                            aria-controls="individual"
                            aria-selected="false"
                            onClick={() =>
                              setFieldValue("register_type", "individual")
                            }
                          >
                            Individual
                          </button>
                        </li>
                      </ul>
                      <div className="my-8 h-px w-full bg-light-grey " />
                    </div>
                    <div className="p-20 product-dContent__box">
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="company"
                          role="tabpanel"
                          aria-labelledby="company-tab"
                          tabIndex={0}
                        >
                          {/* company tab */}
                          <div className="mb-40">
                            <div className="mb-24">
                              <label
                                htmlFor="email"
                                className="text-neutral-900 lable-font  mb-8 fw-medium"
                              >
                                E-mail address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                className="common-input input-font"
                                placeholder="Enter email address"
                                name="email"
                                id="email"
                                onChange={(e) => {
                                  handleChange(e);
                                  loadEmailDetails(e.target.value);
                                }}
                                onBlur={handleBlur}
                                value={values.email}
                                autoComplete="off"
                              />
                              {errors.email && touched.email && (
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="text-danger lable-font "
                                />
                              )}
                            </div>
                            <div className="mb-24">
                              <div className="row">
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="first_name"
                                    className="text-neutral-900 lable-font  mb-8 fw-medium"
                                  >
                                    Your first name{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="common-input input-font"
                                    placeholder="Enter first name"
                                    name="first_name"
                                    id="first_name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.first_name}
                                    autoComplete="off"
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^a-zA-Z\s]/g,
                                        ""
                                      );
                                    }}
                                  />
                                  {errors.first_name && touched.first_name && (
                                    <ErrorMessage
                                      name="first_name"
                                      component="div"
                                      className="text-danger lable-font "
                                    />
                                  )}
                                </div>
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="last_name"
                                    className="text-neutral-900 lable-font  mb-8 fw-medium"
                                  >
                                    Your last name{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="common-input input-font"
                                    placeholder="Enter last name"
                                    name="last_name"
                                    id="last_name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.last_name}
                                    autoComplete="off"
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^a-zA-Z\s]/g,
                                        ""
                                      );
                                    }}
                                  />
                                  {errors.last_name && touched.last_name && (
                                    <ErrorMessage
                                      name="last_name"
                                      component="div"
                                      className="text-danger lable-font " 
                                    />
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="mb-24">
                              <div className="row">
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="company_name"
                                    className="text-neutral-900 lable-font  mb-8 fw-medium"
                                  >
                                    Company legal name{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="common-input input-font"
                                    placeholder="Enter company name"
                                    name="company_name"
                                    id="company_name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.company_name}
                                    autoComplete="off"
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^a-zA-Z\s]/g,
                                        ""
                                      );
                                    }}
                                  />
                                  {errors.company_name &&
                                    touched.company_name && (
                                      <ErrorMessage
                                        name="company_name"
                                        component="div"
                                        className="text-danger lable-font "
                                      />
                                    )}
                                </div>
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="country"
                                    className="text-neutral-900 lable-font  mb-8 fw-medium"
                                  >
                                    Company registration country{" "}
                                    <span className="text-danger">*</span>{" "}
                                  </label>
                                  {email_exits && (
                                    <select
                                      className="common-input input-font"
                                      name="country"
                                      id="country"
                                      disabled={email_exits}
                                      value={countries}
                                    >
                                      <option value={"QAR"}>Qatar</option>
                                      <option value={"AED"}>
                                        United Arab Emirates
                                      </option>
                                      <option value={"OMR"}>Oman</option>
                                      <option value={"SAR"}>
                                        Kingdom of Saudi Arabia
                                      </option>
                                    </select>
                                  )}
                                  {!email_exits && (
                                    <select
                                      className="common-input input-font"
                                      name="country"
                                      id="country"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.country}
                                    >
                                      <option value={"QAR"}>Qatar</option>
                                      <option value={"AED"}>
                                        United Arab Emirates
                                      </option>
                                      <option value={"OMR"}>Oman</option>
                                      <option value={"SAR"}>
                                        Kingdom of Saudi Arabia
                                      </option>
                                    </select>
                                  )}
                                  {errors.country && touched.country && (
                                    <ErrorMessage
                                      name="country"
                                      component="div"
                                      className="text-danger lable-font "
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="mb-24">
                              <div className="row">
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="phone_area_code"
                                    className="text-neutral-900 lable-font  mb-8 fw-medium"
                                  >
                                    Area code{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="common-input input-font"
                                    name="phone_area_code"
                                    id="phone_area_code"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.phone_area_code}
                                  >
                                    <option value={"+971"}>+971</option>
                                    <option value={"+974"}>+974</option>
                                    <option value={"+968"}>+968</option>
                                  </select>
                                  {errors.phone_area_code &&
                                    touched.phone_area_code && (
                                      <ErrorMessage
                                        name="phone_area_code"
                                        component="div"
                                        className="text-danger lable-font "
                                      />
                                    )}
                                </div>
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="phone_nr"
                                    className="text-neutral-900 lable-font  mb-8 fw-medium"
                                  >
                                    Phone number{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="common-input input-font"
                                    placeholder="Enter phone number"
                                    name="phone_nr"
                                    id="phone_nr"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.phone_nr}
                                    autoComplete="off"
                                  />
                                  {errors.phone_nr && touched.phone_nr && (
                                    <ErrorMessage
                                      name="phone_nr"
                                      component="div"
                                      className="text-danger lable-font "
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="individual"
                          role="tabpanel"
                          aria-labelledby="individual"
                          tabIndex={0}
                        >
                          <div className="mb-40">
                            {/* individual tab */}
                            <div className="mb-24">
                              <div className="row">
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="individual_first_name"
                                    className="text-neutral-900 lable-font  mb-8 fw-medium"
                                  >
                                    Your first name{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="common-input input-font"
                                    placeholder="Enter first name"
                                    name="first_name"
                                    id="individualfirst_name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.first_name}
                                    autoComplete="off"
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^a-zA-Z\s]/g,
                                        ""
                                      );
                                    }}
                                  />
                                  {errors.first_name && touched.first_name && (
                                    <ErrorMessage
                                      name="first_name"
                                      component="div"
                                      className="text-danger lable-font "
                                    />
                                  )}
                                </div>
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="country_individual"
                                    className="text-neutral-900 lable-font mb-8 fw-medium"
                                  >
                                    Company{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="common-input input-font"
                                    name="country_individual"
                                    id="country_individual"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.country_individual}
                                    autoComplete="off"
                                  >
                                    <option value={"QAR"}>Qatar</option>
                                    <option value={"AED"}>
                                      United Arab Emirates
                                    </option>
                                    <option value={"OMR"}>Oman</option>
                                    <option value={"SAR"}>
                                      Kingdom of Saudi Arabia
                                    </option>
                                  </select>
                                  {errors.country_individual &&
                                    touched.country_individual && (
                                      <ErrorMessage
                                        name="country_individual"
                                        component="div"
                                        className="text-danger lable-font "
                                      />
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="mb-24">
                              <div className="row">
                                <label
                                  htmlFor="password"
                                  className="text-neutral-900 lable-font mb-8 fw-medium"
                                >
                                  Password{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="position-relative">
                                  <input
                                    type={showPassword ? "text" : "password"} // Toggle between text and password
                                    className="common-input input-font"
                                    id="password"
                                    placeholder="Enter password"
                                    name="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    autoComplete="new-password"
                                  />
                                  {/* Toggle button */}
                                  <span
                                    className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${
                                      showPassword ? "ph-eye" : "ph-eye-slash"
                                    }`}
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                    style={{ cursor: "pointer" }}
                                  />
                                  {errors.password && touched.password && (
                                    <ErrorMessage
                                      name="password"
                                      component="div"
                                      className="text-danger lable-font "
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="mb-24">
                              <div className="row">
                                <label
                                  htmlFor="password_confirmation"
                                  className="text-neutral-900 lable-font  mb-8 fw-medium"
                                >
                                  Password confirmation{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="position-relative">
                                  <input
                                    type={
                                      showConfirmPassword ? "text" : "password"
                                    } // Toggle between text and password
                                    className="common-input input-font"
                                    id="confirm_password"
                                    placeholder="Enter confirm password"
                                    name="password_confirmation"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password_confirmation}
                                    autoComplete="new-password"
                                  />
                                  {/* Toggle button */}
                                  <span
                                    className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${
                                      showConfirmPassword
                                        ? "ph-eye"
                                        : "ph-eye-slash"
                                    }`}
                                    onClick={() =>
                                      setShowConfirmPassword(
                                        !showConfirmPassword
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  />
                                  {errors.password_confirmation &&
                                    touched.password_confirmation && (
                                      <ErrorMessage
                                        name="password_confirmation"
                                        component="div"
                                        className="text-danger lable-font "
                                      />
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="mb-24">
                              <div className="row">
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="phone_area_code"
                                    className="text-neutral-900 lable-font mb-8 fw-medium"
                                  >
                                    Area code{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="common-input input-font"
                                    name="phone_area_code"
                                    id="phone_area_code_individual"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.phone_area_code}
                                    autoComplete="off"
                                  >
                                    <option value={"+971"}>+971</option>
                                    <option value={"+974"}>+974</option>
                                    <option value={"+968"}>+968</option>
                                  </select>
                                  {errors.phone_area_code &&
                                    touched.phone_area_code && (
                                      <ErrorMessage
                                        name="phone_area_code"
                                        component="div"
                                        className="text-danger lable-font "
                                      />
                                    )}
                                </div>
                                <div className="col-sm-6">
                                  <label
                                    htmlFor="phone_nr"
                                    className="text-neutral-900 lable-font  mb-8 fw-medium"
                                  >
                                    Phone number{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="common-input input-font"
                                    placeholder="Enter phone number"
                                    name="phone_nr"
                                    id="phone_nr_individual"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.phone_nr}
                                    autoComplete="off"
                                  />
                                  {errors.phone_nr && touched.phone_nr && (
                                    <ErrorMessage
                                      name="phone_nr"
                                      component="div"
                                      className="text-danger lable-font "
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* common section */}
                        <div className="my-24">
                          <p className="text-gray-500">
                            Please read our&nbsp;
                            <Link
                              to="#"
                              className="btn-primary text-decoration-underline"
                            >
                              Terms of Service
                            </Link>
                            &nbsp;before signing up!
                          </p>
                        </div>
                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-main py-16 px-30 w-full"
                            disabled={loading}
                          >
                            Register
                          </button>
                        </div>
                        <div className="my-24">
                          <p className="text-neutral-900">
                            <b>
                              Already have an account?&nbsp;
                              <Link
                                to="/login"
                                className="btn-primary text-decoration-underline"
                              >
                                Log in
                              </Link>
                            </b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Register Card End */}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default SignUpPage;
